import React, { useEffect, useState } from 'react';
import Wrapper from './styles';
import { stores } from '../../../../../stores';
import { initialBetSlipPlacingState } from '../../../../../services/sports/constants';
import { isMobile } from '../../../../../services/browser';
import { getTicketDetailsByTickedId } from '../../../../../microservices/sbgate';
import { logger } from '../../../../../services/logger';
import { TicketDetails } from '../../../../../services/sports/types';
import { translate } from '../../../../../services/translate';
import UiAlert from '../../../../ui/alert/UiAlert';
import SportTicketDetails from '../../../ticket/details/SportTicketDetails';
import { DATE_YEAR_TIME_FORMAT, getFormattedDate } from '../../../../../services/date';
import { useStore } from '../../../../../hooks/useStore';

interface Props {
    ticketId: string;
}

export default function SportParlayCardBetslipReceipt({ ticketId }: Props) {
    const [isAuthenticated] = useStore(stores.isAuthenticated);
    const [ticketResponse, setTicketResponse] = useState<TicketDetails>();

    useEffect(() => {
        if (ticketId) {
            loadTicketDetails(ticketId);
        }
    }, [ticketId]);

    useEffect(() => {
        if (isAuthenticated) {
            return;
        }
        removeReceipt();
    }, [isAuthenticated]);

    async function loadTicketDetails(ticketId: string) {
        try {
            const response = await getTicketDetailsByTickedId(ticketId);
            setTicketResponse(response);
        } catch (error) {
            logger.error('SportParlayCardBetslipReceipt', 'loadTicketDetails', error);
        }
    }

    function removeReceipt() {
        stores.sports.parlayCard.betSlipPlacingState.set(initialBetSlipPlacingState);
        if (isMobile()) {
            stores.isParlayBetslipOpen.set(false);
        }
    }

    if (!ticketResponse) {
        return null;
    }

    return (
        <Wrapper>
            <p>
                {translate('Bet ID:', 'ui.betslip')} {ticketResponse.ticket.display_id} /{' '}
                <span>
                    {getFormattedDate({
                        date: ticketResponse.ticket.created_at,
                        format: DATE_YEAR_TIME_FORMAT,
                        useDots: true,
                    })}
                </span>
            </p>

            <UiAlert center success>
                {translate('Your bet is placed. Good luck!', 'ui.betslip')}
            </UiAlert>

            <SportTicketDetails ticket={ticketResponse} isCompactView onTicketClosed={removeReceipt} />
        </Wrapper>
    );
}
